import { render, staticRenderFns } from "./ReportSaberPRO.vue?vue&type=template&id=a9c38fa6"
import script from "./ReportSaberPRO.vue?vue&type=script&lang=js"
export * from "./ReportSaberPRO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports